<template>
    <SecondaryPage>
        <div class="max-w-xl py-8 px-4 m-auto">
            <div class="font-bold text-24 text-a-brown-502314 text-center mb-8">Create Account</div>
            <FormRegister ref="form-register" @update:inputValue="onRegisterFormChange($event)"></FormRegister>
            <TermsSector 
                @onTermAcceptChange="onTermAcceptChange($event)"
                @onMarketAcceptChange="onMarketAcceptChange($event)"
            ></TermsSector>
            <RedButton class="mt-8" @click="submitRegister()" :isDisabled="!acceptTerms || !isValidateForm">
                <div>{{lbl.register.register}}</div>
            </RedButton>
        </div>
    </SecondaryPage>
</template>
<script>
import Util from '@/helper/Utility'
import CacheHelper from '@/helper/CacheHelper'
import { CacheKey } from '@/helper/StaticValue'
//component
import SecondaryPage from '@/components/Layout/Page/SecondaryPage.vue'
import FormRegister from '../component/FormRegister/FormRegister.vue'
import TermsSector from '../component/TermsSector/TermsSector.vue'
import RedButton from '@/components/Button/RedButton.vue'
//mixin
import ModalMixin from '@/mixin/ModalMixin'
import LocaleMixin from '@/mixin/LocaleMixin';
//service
import RegisterApi from '../service/RegisterApi'
import BzbsOtp from '@/core/Account/service/BzbsOtp'



export default {
    mixins: [ModalMixin,LocaleMixin],
    components: {
        SecondaryPage,
        FormRegister,
        TermsSector,
        RedButton,
    },
    data: function () {
        return {
            acceptTerms: false,
            acceptMarketing: false,
            isValidateForm: false,
            registerModel: null,

            pathAfterLogin: null,
        };
    },
    created: function() {
        let afterLogin = this.$route.query.afterLogin;
        if (!Util.isEmptyStr(afterLogin)) {
            this.pathAfterLogin = afterLogin;
        }
    },
    methods: {
        onTermAcceptChange: function (terms) {
            this.acceptTerms = terms;
        },
        onMarketAcceptChange: function (acceptMarket) {
            this.acceptMarketing = acceptMarket;
        },
        onRegisterFormChange: function (isValidate) {
            this.isValidateForm = isValidate.rs;
        },
        submitRegister: async function () {
            this.tracking.event('register','click_submit_new_register', null, null);
            if (!this.acceptTerms) return;
            
            let rs = this.$refs['form-register'].validateForm();
            if (rs.rs == false) {
                let msg = rs.error.msg;
                this.modal.errorModal
                    .clearModal()
                    .setMsg(msg)
                    .show();
            } else {
                this.registerModel = this.$refs['form-register'].getFormValue();
                this.registerModel.setAcceptTermsAndPrivacy(this.acceptTerms)
                this.registerModel.setAcceptMarketing(this.acceptMarketing)

                // Util.log('register model', this.registerModel);
                // Util.log('register model', this.registerModel.getParams());
                // if (await this.apiValidateRegister()) {
                //     this.flowRegisterOtp();
                // }
                this.apiValidateRegister();
                
            }
        },
        flowRegisterOtp: async function (otpData) {
            this.modal.otpModal.clearModal()
                .setTel(this.registerModel.tel)
                .setDisableRequestOtp()
                .setRefcode(otpData.refcode)
                .setOtpLifeTime(otpData.expireinseconds)
                .setOtpChanel('register')
                .startOtp();
            this.modal.otpModal.onSubmitOtp((otpModel) => {
                this.flowValidateOtp(otpModel);
            });
        },
        flowValidateOtp: async function (otpModel) {
            // console.log('submit otp', otpModel);
            this.registerModel.setOtpModel(otpModel)

            // Util.log('register model', this.registerModel);

            this.modal.loadingModal.show();
            let validateOtpResult = await this.apiValidateOtp();
            this.modal.loadingModal.hide();

            if (validateOtpResult) {
                this.saveCacheFormRegister();
                this.modal.otpModal.closeOtp();
                //this.$router.push('/register/password');
                this.openNextPage('register_password');
            }
        },
        openNextPage: function (pathName) {
            let query = null;
            if (this.pathAfterLogin != null) {
                query = {
                    afterLogin: this.pathAfterLogin,
                };
            }
            this.$router.replace({
                name: pathName,
                query: query,
            });
        },
        apiValidateRegister: function () {
            return new Promise((resolve) => {
                let params = this.registerModel.getParamsValidateRegister();
                RegisterApi.apiValidateRegister(params).subscribe({
                    next: (data) => {
                        console.log('validate otp', data);
                        this.flowRegisterOtp(data);
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        resolve(false);
                        if (err.id == 2089) {
                            this.modal.errorModal
                                .clearModal()
                                .setMsg(this.lbl.register.error_email_duplicate)
                                .show();
                        } else if (err.id == 2078) {
                            this.modal.errorModal
                                .clearModal()
                                .setMsg(this.lbl.register.error_mobile_duplicate)
                                .show();
                        } else {
                            this.errorApi(err);
                        }
                    },
                })
            });
        },
        apiValidateOtp: function () {
            return new Promise((resolve) => {
                let contactNumber = this.registerModel.tel;
                let refcode = this.registerModel.otpModel.refcode;
                let otp = this.registerModel.otpModel.otp;
                let channel = this.registerModel.otpModel.channel;

                BzbsOtp.validateOtp(contactNumber, refcode, otp, channel).subscribe({
                    next: (data) => {
                        console.log('validate otp', data);
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        resolve(false);

                        if (err.id == 2091) {
                            this.modal.otpModal.setErrorMsg(this.lbl.register.otp_popup.invalid_otp);
                            this.modal.otpModal.clearInputOtp();
                        } else {
                            this.errorApi(err);
                        }
                    },
                })
            });
        },

        saveCacheFormRegister: function () {
            let cache = new CacheHelper('session');
            cache.setCache(CacheKey.formRegister, this.registerModel);
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
